/* Publish by EComposer at 2025-07-31 19:35:48*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-yfuzq8ohg17"]=  window.__ectimmers["ecom-yfuzq8ohg17"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),o=e.querySelector(".text-content.ecom-html");!o||(i&&i.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-yfuzq8ohg17').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yfuzq8ohg17', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}